/* На каждый шаблон свой JS модуль */
import { PHP } from '../PHP';
import { joint } from '../joint';
//import { objMenu } from '../../edit/js/objMenu';
//import { blockMenu } from '../../edit/js/blockMenu';
//import { } from '../lib/cards';
//import { like } from '../lib/like';
//import {CardFA} from '../lib/CardFA';
//import {ObjList} from '../lib/ObjList';

window.unit.cat = {
	init() {
		const albom = document.querySelector(".albom");
		if(PHP.debug >0) console.log('cat.js >init()');
		//console.log('=== cat.js ===');

		/*=============================
		 Теперь ../lib/cards' здесь;
		===============================*/
		var reqOffset = PHP.pgMore;
		var reqLimit = reqOffset;
		if (boxCards = document.querySelector('.box')) {
			let showMore = document.querySelector('.showMore');
			if(!showMore) return;
			showMore.addEventListener("click", () => {
				//joint.getData('/?t='+JED.tmpl+'&a=more&id=' + JED.pgId + '&ptr=' + reqOffset + '&ed=' + '1', function (data) {
				joint.getData('/?t=' + JED.tmpl + '&a=more&id=' + JED.pgId + '&ptr=' + reqOffset, function (data) {
					var result = '';
					//console.log('data='+data);
					if (data != 0) {
						data = JSON.parse(data);
						for (id in data) {
							boxCards.insertAdjacentHTML('beforeend', data[id]);
						}
						//Для подгруженных карточек нужно заново активировать менюшки
						if (JED.tune.edit) objMenu.init();
					} else {//Надо скрыть ссылку Показать ещё
						document.querySelector('.showMore').style.color = '#aaa';
					}
					reqOffset += reqLimit;
				})
			}, false);
		}
	}
}